
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    theme: {
      type: String,
      validator: (value: string) => ['primary', 'secondary'].includes(value),
      default: () => 'primary',
    },
    padding: {
      type: String,
      validator: (value: string) => ['sm', 'lg'].includes(value),
      default: () => 'lg',
    },
  },
})
